import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	EnvironmentInjector,
	inject,
	OnInit,
	runInInjectionContext,
} from '@angular/core';
import { IonButton, IonContent, IonFooter } from '@ionic/angular/standalone';
import { LangSwitcherComponent } from '../../../shared/ui/lang-switcher/lang-switcher.component';
import { ModalController } from '@ionic/angular';
import { AddressService } from '../../maps/services/address.service';
import { PushNotificationService } from '../../../core/services/push-notification.service';
import { TranslatePipe } from '@ngx-translate/core';
import { UserStateService } from '../../../state/user/user-state';
import { skip } from 'rxjs';

@Component({
	selector: 'app-permission-request',
	templateUrl: './permission-request.component.html',
	styleUrls: ['./permission-request.component.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [IonContent, IonFooter, LangSwitcherComponent, IonButton, TranslatePipe],
})
export class PermissionRequestComponent implements OnInit {
	locationPermissionAvailable = false;
	pNPermissionAvailable = false;

	static async show(modalCtrl: ModalController, locationPermissionAvailable: boolean, pNPermissionAvailable: boolean) {
		const modal = await modalCtrl.create({
			component: PermissionRequestComponent,
			cssClass: 'checkout-modal',
			componentProps: {
				locationPermissionAvailable,
				pNPermissionAvailable,
			},
		});
		await modal.present();
		const res = await modal.onDidDismiss();
		return res.data;
	}

	static async checkAndRequestPermissions(injector: EnvironmentInjector) {
		await runInInjectionContext(injector, async () => {
			const addressSvc = inject(AddressService);
			const pNSvc = inject(PushNotificationService);
			const modalCtrl = inject(ModalController);
			const location = !!(await addressSvc.ifPermissionCanBeRequested());
			const pN = await pNSvc.ifPermissionCanBeRequested();
			if (pN || location) await PermissionRequestComponent.show(modalCtrl, location, pN);
		});
	}

	private addressSvc = inject(AddressService);
	private pNSvc = inject(PushNotificationService);
	private userStateSvc = inject(UserStateService);
	private cdr = inject(ChangeDetectorRef);
	private modalCtrl = inject(ModalController);
	private dismissed = false;
	constructor() {}

	ngOnInit() {
		this.userStateSvc.address$.pipe(skip(1)).subscribe(address => {
			this.locationPermissionAvailable = false;
			this.close();
		});
	}

	async requestLocationPermission() {
		await this.addressSvc.initUserPosition();
		this.locationPermissionAvailable = false;
		this.close();
	}
	async requestPnPermission() {
		await this.pNSvc.init();
		this.pNPermissionAvailable = false;
		this.close();
	}

	async close() {
		if (!this.locationPermissionAvailable && !this.pNPermissionAvailable && !this.dismissed) {
			this.dismissed = true;
			await this.modalCtrl.dismiss();
		}
		this.cdr.detectChanges();
	}
}
